import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteVenta;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un CorteVenta
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        FechaCorte: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un CorteVenta
*/
export class CorteVentaEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const hasError = this.hasError(this.props);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Agregar Corte"
            >

                {kea.autogrid(6, [
                    <DateTime field="FechaCorte" label="Fecha de corte" time={true} />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteventas/list/modalagregar.tsx